import React, { Component } from "react";
import { UncontrolledAlert, Button } from "reactstrap";
import { withFormsy } from "formsy-react";
import { metricsService } from "./services/metrics.service";
import { MySelect } from "../../Shared/Forms";
import { Spinner } from "../../Shared";

class MetricsDropDown extends Component {
  state = {
    fetching: false,
    fetched: false,
    response: null,
    error: null
  };

  componentDidMount() {
    this.getActivities();
  }

  getActivities = async params => {
    this.setState({
      ...this.state,
      fetching: true
    });
    try {
      let response = await metricsService.getAllMetrics(params);
      if (response) {
        
       let metricData=response.content.filter(value=>{return value.id !==1 }).map(value=>{return value} )
        this.setState({
          ...this.state,
          fetching: false,
          fetched: true,
          response:metricData,
          error: null
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetching: false,
        fetched: false,
        error
      });
    }
  };



  render() {
    const {
      name,
      value,
      disabled,
      isMulti,
      title,
      isRequired,
      isClearable
    } = this.props;

    const { fetching, response, error } = this.state;
   
    return (
      <div>
        {fetching ? (
          <UncontrolledAlert color="info">
            <Spinner message="Fetching Metrics" />
          </UncontrolledAlert>
        ) : (
          <div>
            <MySelect
              isMulti={isMulti}
              name={name}
              isClearable={isClearable}
              title={title}
              options={response ? response : []}
              value={value}
              valueKey="id"
              disabled={disabled}
              labelKey="name"
              innerRef={c => {
                this.metrics = c;
              }}
              required={isRequired}
            />
            {!response && error && (
              <UncontrolledAlert color="danger">
                {error.message}
                <div className="text-reight">
                  <Button color="danger" onClick={this.getCoreCurrencies}>
                    Retry
                  </Button>
                </div>
              </UncontrolledAlert>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withFormsy(MetricsDropDown);
